import { render, staticRenderFns } from "./listaPuentes.vue?vue&type=template&id=414986c9&"
import script from "./listaPuentes.vue?vue&type=script&lang=js&"
export * from "./listaPuentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports